// extracted by mini-css-extract-plugin
export default {"root":"filters-footer_root__I1tkV","custom-filters":"filters-footer_custom-filters__C6ul6"};